import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative bg-brand-cream-light py-16 md:py-24 overflow-hidden" data-id="element-130">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-131">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-132"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-brand-orange rounded-full blur-3xl" data-id="element-133"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-134">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-135">
          {/* Left: Text Content */}
          <div className="text-center lg:text-left" data-id="element-136">
            <FadeIn delay={0.1} data-id="element-137">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-brown leading-tight mb-8" data-id="element-138">
                La Milhojas Perfecta: <br className="hidden md:block" data-id="element-139" />
                <span className="text-brand-gold-dark" data-id="element-140">
                  12 Capas Crocantes
                </span>{' '}
                que se Deshacen en la Boca
                <span className="block text-2xl md:text-3xl mt-4 font-normal text-brand-brown/80" data-id="element-141">
                  — Logradas en Casa, Sin Máquinas Profesionales
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-142">
              <p className="text-lg md:text-xl text-brand-brown/80 mb-10 max-w-3xl leading-relaxed" data-id="element-143">
                El método paso a paso de Stella Pereira para que cualquier
                persona — aunque nunca haya hecho pastelería — logre una
                milhojas digna de las mejores confiterías argentinas.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-144">
              <div className="flex flex-col items-center lg:items-start gap-4 mb-12" data-id="element-145">
                <div className="bg-white/60 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-warm border border-brand-gold/20 inline-block text-left" data-id="element-146">
                  <ul className="space-y-3" data-id="element-147">
                    <li className="flex items-center text-brand-brown font-medium" data-id="element-148">
                      <span className="mr-3 text-xl" data-id="element-149">⚡</span> Masa ultra-fina
                      con técnica profesional sin sobadora
                    </li>
                    <li className="flex items-center text-brand-brown font-medium" data-id="element-150">
                      <span className="mr-3 text-xl" data-id="element-151">⚡</span> Merengue italiano
                      que no falla ni en verano
                    </li>
                    <li className="flex items-center text-brand-brown font-medium" data-id="element-152">
                      <span className="mr-3 text-xl" data-id="element-153">⚡</span> Resultado
                      profesional desde el primer intento
                    </li>
                  </ul>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-154">
              <CTAButton isPayment={false} href="#offer" className="text-xl px-10 py-5" data-id="element-155">
                🛒 Sí, quiero aprender el método ahora
              </CTAButton>
            </FadeIn>
          </div>

          {/* Right: Milhojas Image */}
          <FadeIn delay={0.2} direction="right" data-id="element-156">
            <div className="relative flex justify-center" data-id="element-157">
              <div className="relative" data-id="element-158">
                <img src="https://cdn.magicpatterns.com/uploads/1xgu9UERBJuVRSn7tAGFi2/milhoja.png" alt="Milhojas perfecta con merengue italiano" className="rounded-3xl shadow-warm-lg w-full max-w-lg object-cover" data-id="element-159" />
                <div className="absolute -bottom-4 -right-4 bg-brand-orange text-white font-bold text-lg px-6 py-3 rounded-2xl shadow-lg transform rotate-3" data-id="element-160">
                  ¡Vos podés lograr esto!
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}